export default __webpack_public_path__ + "static/media/h2.1f2327ba.jpg";